import { DEFAULTS, type NotifPrefs } from '../domain/notif-prefs.model';

/** Redux state for the account "Notifications" tab: the current per-channel prefs. */
export interface NotificationPreferencesState {
  prefs: NotifPrefs;
}

export const initialState: NotificationPreferencesState = {
  prefs: DEFAULTS,
};
